import {
  FieldsOnlyOfficeV3,
  IProfile,
  IQueryParameters,
  ITemplate,
  ITemplateById,
  ITemplateApiError,
  ITemplateProfile,
  ITemplateStatusSummary,
  ITemplates,
} from '@literax/models/templates';
import { IField } from '@literax/models/templates-fields.model';
import {
  FilterParams,
  TemplateCollector,
  TemplateFieldData,
  TemplateSigner,
} from '@literax/models/templates-reports.model';
import { IPagination, IPaginationV3 } from '@literax/models/pagination.model';

import { ColumnSort } from '@literax/models/table.model';
import { ETemplateProcessKind } from '@literax/enums/template.enum';
import { IAPIResponseError } from '@literax/models/http/api/error.model';
import { Process } from '@literax/models/process.model';

export interface ITemplatesState {
  updated: ITemplates;//v2
  templates: ITemplates[];//v2
  latest: ITemplates[];//v2
  templateUpdate: ITemplates;//v2
  error: IAPIResponseError | ITemplateApiError;
  currentPage: number;//v2
  pagination: IPagination;//v2
  flows: Process;//v2
  selectedFlow: string;//v2
  sortColumn: string;//v2
  currentDepartment: number;//v2
  kind: string;//v2
  metadataTemplateProfiles: ITemplateProfile[];
  metadataTemplateProfilesCurrentPage: number;
  profiles: IProfile[];
  templateFieldData: TemplateFieldData;
  templateFieldDataCurrentPage: number;
  templateFieldDataCurrentSort: ColumnSort[];
  templateFieldDataActiveFilter: FilterParams;
  collectors: TemplateCollector[];
  signers: TemplateSigner[];
  queryParameters: IQueryParameters;
  templatesV3: ITemplate[];
  paginationV3: IPaginationV3;
  templateById: ITemplateById;
  templateUpdateV3:ITemplateById;
  fieldsOnlyOfficeV3: FieldsOnlyOfficeV3[];
  /** Numeric kind filter of the v3 list; null lists every kind (FR-014). */
  kindV3: ETemplateProcessKind | null;
  forceDepartments: boolean;
  /** Metadata catalog available to the open template, accumulated page by page. */
  templateCatalogV3: IField[];
  /** Paging of the last catalog page loaded. */
  templateCatalogPaginationV3: IPaginationV3;
  /** Search term applied to the fields of the open template. */
  templateFieldsSearch: string;
  /** Counts of the list status tabs. */
  templateStatusSummaryV3: ITemplateStatusSummary;
}

export const initialTemplatesState: ITemplatesState = {
  updated: {},
  templates: [],
  latest: [],
  templateUpdate: null,
  error: null,
  currentPage: 1,
  pagination: {
    currentPage: 1,
    pageSize: 10,
    total_count: null,
    total_pages: null,
  },
  selectedFlow: 'template_draft',
  flows: null,
  sortColumn: 'created_at:desc',
  currentDepartment: null,
  kind: '',
  metadataTemplateProfiles: [],
  metadataTemplateProfilesCurrentPage: 1,
  profiles: [],
  templateFieldData: null,
  templateFieldDataCurrentPage: 1,
  templateFieldDataCurrentSort: [],
  templateFieldDataActiveFilter: null,
  collectors: [],
  signers: [],
  queryParameters: {
    pageNumber: 1,
    pageSize: 10,
    sortField: null,
    filterFields: [],
  },
  templatesV3: [],
  paginationV3: null,
  templateById: null,
  templateUpdateV3: null,
  fieldsOnlyOfficeV3: null,
  kindV3: null,
  forceDepartments: false,
  templateCatalogV3: [],
  templateCatalogPaginationV3: null,
  templateFieldsSearch: '',
  templateStatusSummaryV3: null,
};
